// src/admin/Admin.js
import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';

const Admin = () => {
  return (
    <div className='container'>
      <h2>Admin Dashboard</h2>

      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="login" element={<Login />} />
      </Routes>
    </div>
  );
}

export default Admin;
